
import { useMemo } from "react";
import { Spinner } from "reactstrap";
import "./ResultEntry.scss";

export const ResultEntry = (props) => {
  const { idx, status, bib, isSuccess, isEditable, isSaving, onClick } = props;

  const rootClassName = useMemo(() => {
    if (status === "waiting") return "";
    else if (status === "active") return "shootout-resultentry-root--active";
    else return `shootout-resultentry-root--${isSuccess ? "success" : "fail"}`;
  }, [status, isSuccess]);

  return (
    <div
      className={`shootout-resultentry-root ${rootClassName} ${
        isEditable && !isSaving ? "shootout-resultentry-root--editable" : ""
      }`}
      onClick={isEditable && !isSaving ? onClick : undefined}
    >
      <div className="shootout-resultentry-shootcounter">{idx}</div>
      {isSaving && <Spinner className="shootout-resultentry-spinner" size="sm" />}
      {status === "handled" && !isSaving && <div className="shootout-resultentry-player">{bib}</div>}
      {status === "handled" && !isSaving && (
        <div className={`shootout-resultentry-mark shootout-resultentry-mark--${isSuccess ? "success" : "fail"}`}>
          <i className={`fas ${isSuccess ? "fa-check" : "fa-times"}`} />
        </div>
      )}
    </div>
  );
};
